import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { Divider, Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next";
import { Box } from "@mui/system";
import {INumericSummaryProps, NumericSummaryData} from "./TheftMisappropriationInterfaces";
import {STATE_SUMMARY_UPDATING} from "./Constants";

export const NumericSummary = (props: INumericSummaryProps) => {

    const { t } = useTranslation('finessecurity', {keyPrefix: 'theftMisappropriate'});

    const {filters} = props;

    const [summary, setSummary] = useState<NumericSummaryData[]>(props.fields.map<NumericSummaryData>(it => ({ key: it, value: 0 })));
    const [updating, setUpdating] = useRecoilState(STATE_SUMMARY_UPDATING);

    useEffect(() => {
        if (updating && filters.legalEntities) {
            let array: NumericSummaryData[] = [];

            props.query()
                .then(response => {
                    let result = response.result;

                    props.fields.forEach(it => {
                        array.push({ key: it, value: result[it] });
                    });

                    setSummary(array);
                })
                .finally(() => {
                    setUpdating(false);
                })
        }
    }, [updating, filters])


    const insertBetween = (element: any, array: any) => {
        return array.flatMap((x: any) => [element, x]).slice(1);
    };


    return (
        <Stack direction="row" justifyContent="space-between">
            <Stack direction="row" alignItems="center" columnGap={2} fontSize=".9rem">
                {insertBetween(
                    <Divider orientation="vertical" variant="middle" flexItem/>,
                    summary.map(it =>
                        <Stack direction="row" columnGap={1}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <Typography variant="subtitle2" fontSize=".9rem" color={'primary'}>{t(`${props.label}.${it.key}`)}: <strong>{it.value}</strong></Typography>
                            </Box>
                        </Stack>
                    ))}
            </Stack>
        </Stack>
    );
}